import React from "react";
import { DoubleRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

export const INVOICE_STATUS_IN_REVIEW = "In Review";
export const INVOICE_STATUS_ACCEPTED = "Accepted";
export const INVOICE_STATUS_PAID = "Paid";

export const invoiceStatus = [
    {
        value: INVOICE_STATUS_IN_REVIEW,
        key: INVOICE_STATUS_IN_REVIEW,
        name: INVOICE_STATUS_IN_REVIEW,
        text: INVOICE_STATUS_IN_REVIEW,

        color: "#87d068",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: INVOICE_STATUS_ACCEPTED,
        key: INVOICE_STATUS_ACCEPTED,
        name: INVOICE_STATUS_ACCEPTED,
        text: INVOICE_STATUS_ACCEPTED,

        color: "#108ee9",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        value: INVOICE_STATUS_PAID,
        key: INVOICE_STATUS_PAID,
        name: INVOICE_STATUS_PAID,
        text: INVOICE_STATUS_PAID,

        color: "#f50",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
];

export const isFinalStatus = (status) => {
    if (status == INVOICE_STATUS_PAID) {
        return true;
    }
    return false;
};
